module.exports = __webpack_public_path__ + "static/media/Home.f93f8fe4.png";